import { AddressRegionMappedItem, AddressRegionsLogicService } from '@app/logic/address-regions';
import { Component } from '@angular/core';
import { AddressRegionDialogComponent } from './components/address-region-dialog/address-region-dialog.component';
import { BaseSimpleListViewDirective } from '@app/shared/base-views/base-simple-list-view.directive';
import { PermissionsPermissions } from '../../../../core/permissions';
import { ToastService } from '@app/core/services/toast/toast.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { CbDialogService } from '@app/shared/components/dialog/cb-dialog.service';
import { IAddressRegionDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { take } from 'rxjs';

@Component({
    selector: 'cb-address-regions',
    templateUrl: './address-regions.component.html',
    styleUrls: ['./address-regions.component.scss'],
    providers: [AddressRegionsLogicService],
    standalone: false
})
export class AddressRegionsComponent extends BaseSimpleListViewDirective<IAddressRegionDto, AddressRegionsLogicService> {
    public sortOrderChanged = false;

    public readonly displayedColumns: string[] = ['Name', 'Active', ''];

    public savingOrder = false;

    constructor(
        public readonly toastService: ToastService,
        public readonly permissionsPermissions: PermissionsPermissions,
        public readonly dialog: CbDialogService,
        private readonly addressRegionsLogicService: AddressRegionsLogicService
    ) {
        super(
            dialog,
            addressRegionsLogicService,
            AddressRegionDialogComponent,
            'Address Region',
            AddressRegionMappedItem,
            permissionsPermissions
        );
    }

    public drop(event: CdkDragDrop<IAddressRegionDto[]>) {
        if (event.previousIndex === event.currentIndex) return;
        moveItemInArray(this.searchResults, event.previousIndex, event.currentIndex);
        this.sortOrderChanged = true;
    }

    protected handleNewItem = (item: any) => {
        super.handleNewItem(item);
    };

    protected handleSearchResults = (searchResults: Array<IAddressRegionDto>) => {
        super.handleSearchResults(searchResults);
    };

    public saveOrder(): void {
        this.dialog
            .confirm({
                message: 'Are you sure you want to save the order of the Address Regions?',
                declined: () => {
                    this.savingOrder = false;
                },
                confirmed: this.handleSaveOrder,
            });
    }

    private readonly handleSaveOrder = (): void => {
        this.addressRegionsLogicService
            .saveOrder(this.searchResults)
            .pipe(take(1)).subscribe((result) => {
                this.searchResults = result;
                this.sortOrderChanged = false;
                this.savingOrder = false;
            });
    };
}
